import inDOM from 'dom-helpers/canUseDOM'
import get from 'lodash/get'
import defer from 'lodash/defer'
import { ROUTE_CONTENT, CONTENT_TYPE } from '../actions'
import { ActionType } from 'redux-promise-middleware'
import isNumber from 'lodash/isNumber'

let scrollTo

export default store => next => action => {
  if (inDOM) {
    if (action.type === ROUTE_CONTENT) {
      scrollTo = get(action, ['meta', 'scrollTo'])
    } else if (action.type === `${CONTENT_TYPE}_${ActionType.Fulfilled}`) {
      if (scrollTo || scrollTo === 0) {
        defer(() => {
          const offset = isNumber(scrollTo) ? scrollTo : get(document.querySelectorAll(scrollTo), [0, 'offsetTop'], 0)
          window.scrollTo({
            top: offset,
            left: 0,
            behavior: 'smooth'
          })
        })
      } else {
        // We are doing the scroll update in the page after the transition
        // updateScroll()
      }
    }
  }
  return next(action)
}
